import gql from 'graphql-tag';

const PatronRewardFields = gql`
  fragment PatronRewardFields on PatronReward {
    prizeCode
    prizeName
    prizeType
    startDate
    endDate
    isEarnRequired
    earnType
    earnOverDays
    earnAmount
    promoType
    maxPrizesPerPeriod
    redeemed
  }
`;

const HotelOfferFields = gql`
  fragment HotelOfferFields on HotelOffer {
    numberOfNights
    bookingStartDate
    bookingEndDate
    name
    patronReward {
      ...PatronRewardFields
    }
  }
  ${PatronRewardFields}
`;

const CalendarDayFields = gql`
  fragment CalendarDayFields on HotelCalendarDay {
    date
    isCompable
    isBlockCodeDay
    roomRates {
      rates {
        base {
          amount
        }
      }
      total {
        amount
        currencyCode
      }
      roomTypeCode
      ratePlanCode
      eligibleForComp
      offers {
        ...HotelOfferFields
      }
    }
    occupancy {
      roomTypeCode
      totalRooms
      overBookingLimit
      soldDeductible
      soldNonDeductible
      totalAvailableRooms
    }
    restrictions {
      restrictionType
      numberOfDays
      roomType
      rateCode
    }
    hasAvailability
    missingRackRates
  }
  ${HotelOfferFields}
`;

const HotelProfileFields = gql`
  fragment HotelProfileFields on HotelProfile {
    netTheo
    netTheo365d
    reinvestmentRate
    operaProfile {
      firstName
      lastName
      phone
      email
      operaId
      customerValue
      address {
        addressLine
        cityName
        stateProv
        countryCode
        postalCode
      }
    }
    patronBookingInfo {
      patronAccountNumber
      firstName
      lastName
      email
      rewardsJoinDate
      homePhone
      mobilePhone
      addressLine1
      addressLine2
      city
      stateProv
      postalCode
      compBalance
      clubState
    }
  }
`;

const PriceFields = gql`
  fragment PriceFields on HotelPrice {
    amount
    currencyCode
    decimals
  }
`;

export default {
  PatronRewardFields,
  HotelOfferFields,
  CalendarDayFields,
  HotelProfileFields,
  PriceFields
};
